var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContacts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.666h21.34c1.47 0 2.66 1.197 2.66 2.653v21.36a2.657 2.657 0 0 1-2.66 2.654H4V2.666zm5.333 2.667H6.667v21.333h2.666V5.333zM12 26.666h13.333V5.333H12v21.333zm2.667-5.333a4 4 0 1 1 8 0h-8zm4-5.334a2.667 2.667 0 1 1 0-5.333 2.667 2.667 0 0 1 0 5.333zm10.666-8H32v5.334h-2.667V7.999zm0 8H32v5.334h-2.667v-5.334z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContacts);
export default __webpack_public_path__ + "static/media/ic-contacts.0d9ce9796b2154a201861904fb3991d3.svg";
export { ForwardRef as ReactComponent };